import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import GlobalSearch from "@/components/feature/GlobalSearch";

const featured = movies.filter((m) => m.featured);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((i) => (i + 1) % featured.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((i) => (i + dir + featured.length) % featured.length);
  };

  return (
    <section className="relative h-[560px] w-full overflow-hidden md:h-[620px]">
      {featured.map((movie, i) => (
        <div
          key={movie.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <img
            src={movie.wide}
            alt={`${movie.title} 剧照`}
            title={`${movie.title} 小黄人电影`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-semibold text-foreground-950">
            <i className="ri-fire-line"></i>
            本周焦点推荐
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            {featured[index].title}
          </h1>
          <p className="mt-2 text-sm text-background-200 md:text-base">
            {featured[index].originalTitle} · {featured[index].year} · {featured[index].type} ·{" "}
            {featured[index].duration}
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            {featured[index].synopsis}
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${featured[index].id}`}
              className="flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-foreground-950 transition hover:bg-primary-400"
            >
              <i className="ri-play-circle-line text-lg"></i>
              查看剧情详情
            </Link>
            <Link
              to="/category"
              className="flex items-center gap-2 rounded-full border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-background-50/10"
            >
              <i className="ri-movie-2-line text-lg"></i>
              浏览全片库
            </Link>
          </div>

          <div className="mt-8 max-w-md">
            <GlobalSearch variant="hero" placeholder="搜索电影、资讯或影评…" />
          </div>
        </div>

        <div className="mt-10 flex items-center gap-4">
          <div className="flex items-center gap-2">
            {featured.map((movie, i) => (
              <button
                key={movie.id}
                type="button"
                aria-label={`切换到 ${movie.title}`}
                onClick={() => setIndex(i)}
                className={`h-2.5 rounded-full transition-all ${
                  i === index ? "w-7 bg-primary-500" : "w-2.5 bg-background-50/50"
                }`}
              ></button>
            ))}
          </div>
          <div className="ml-auto hidden items-center gap-2 md:flex">
            <button
              type="button"
              aria-label="上一个"
              onClick={() => go(-1)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition hover:bg-background-50/10"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              type="button"
              aria-label="下一个"
              onClick={() => go(1)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition hover:bg-background-50/10"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}